module.exports = __webpack_public_path__ + "static/d3-e00eb17035af201a88a6e0ad78552384.jpg";